export default __webpack_public_path__ + "static/media/hotService4.38ed09a5.svg";